export default __webpack_public_path__ + "static/12aa-133a09500abcc211eb5ab45378d502b4.png";